module.exports = __webpack_public_path__ + "fonts/gothica1-bold-webfont.977e2e2.woff";